export const VISIBILITIES = ['public_visibility', 'protected_visibility', 'private_visibility'];

export const NOT_SORT_CELLS = ['Field::DateTime', 'HoldField::Yaw::JourneyCreatedAt'];

export const FIELD_GROUPS = [
  {
    options: [
      {
        type: 'text',
        icon: 'slp-font',
      },
      {
        type: 'selection',
        icon: 'slp-circle-o',
      },
    ],
  },
  {
    options: [
      {
        type: 'datetime',
        icon: 'slp-date',
      },
      {
        type: 'Field::CascadedSelect',
        icon: 'fa-sitemap',
      },
      {
        type: 'Field::Organization',
        icon: 'fa-users',
      },
      {
        type: 'Field::Member',
        icon: 'slp-user-o',
      },
      {
        type: 'Field::Calculation',
        icon: 'slp-function',
      },
    ],
  },
  {
    options: [
      {
        type: 'Field::Rating',
        icon: 'slp-star',
      },
      {
        type: 'Field::File',
        icon: 'fa-cloud-upload',
      },
      {
        type: 'Field::Esignature',
        icon: 'slp-pencil-square',
      },
      {
        type: 'Field::Location',
        icon: 'slp-map-marker',
      },
    ],
  },
  {
    options: [
      {
        type: 'Field::Detail',
        icon: 'fa-list-alt',
      },
    ],
  },
];

export const GROUP_MAP = {
  text: [
    {
      type: 'Field::TextField',
      icon: 'slp-single-line-text',
    },
    {
      type: 'Field::TextArea',
      icon: 'slp-multiple-lines-text',
    },
    {
      type: 'Field::Integer',
      icon: 'slp-integer-circle-o',
    },
    {
      type: 'Field::IDNumber',
      icon: 'slp-id-card-o',
    },
    {
      type: 'Field::Phone',
      icon: 'slp-phone-o',
    },
  ],
  selection: [
    {
      type: 'Field::RadioButton',
      icon: 'slp-circle-o',
    },
    {
      type: 'Field::CheckBox',
      icon: 'slp-square-o',
    },
  ],
  datetime: [
    {
      type: 'Field::DateTime',
      icon: 'slp-date',
      params: { input_type: 'date' },
    },
    {
      type: 'Field::DateTime',
      icon: 'slp-time-circle-o',
      params: { input_type: 'time' },
    },
    {
      type: 'Field::DateTime',
      icon: 'slp-date',
      params: { input_type: 'datetime-local' },
    },
  ],
};
